"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFiatReplenishFee = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _actions = require("../../actions");
var initialState = {
  loading: false,
  data: undefined
};
var getFiatReplenishFee = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(_actions.getReplenishFeeAction.pending, function (state) {
    state.loading = true;
    state.data = initialState.data;
  }).addCase(_actions.getReplenishFeeAction.rejected, function (state) {
    state.loading = false;
  }).addCase(_actions.getReplenishFeeAction.fulfilled, function (state, action) {
    state.loading = false;
    state.data = action.payload;
  });
});
exports.getFiatReplenishFee = getFiatReplenishFee;